var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Power = function Power(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M13 4a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0V4Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "M7.645 6.764a1 1 0 0 0-1.29-1.528 8.75 8.75 0 1 0 11.29 0 1 1 0 0 0-1.29 1.528 6.75 6.75 0 1 1-8.71 0Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default Power;